import sharedAssets from "@/assets/shared";
import siteLinks from "@/data/siteLinks";
import { POSTHOG_EVENT } from "@/services/posthog/data";
import useTracker from "@/tracking/useTracker";

const FacebookBanner = () => {
  const { track } = useTracker();

  const handleEventRegiter = () => {
    track(POSTHOG_EVENT.JOIN_FACEBOOK_CTA_CLICKED);
  };

  return (
    <div className="flex w-full flex-col justify-between gap-4 rounded-lg bg-[#1877F2] p-6 text-white shadow-lg sm:flex-row sm:p-10">
      <div className="flex gap-4 sm:items-center">
        <img
          src={sharedAssets.facebook}
          alt="Verify Email Logo"
          className="h-11 w-11 sm:h-14 sm:w-14"
        />
        <div className="flex flex-col gap-1">
          <p className="text-sm sm:text-lg md:text-2xl">
            The Aftershoot Facebook Community
          </p>
          <p className="text-xs font-light sm:text-base md:text-base">
            Join over 12K+ photographers that are dedicated to improving their
            post-processing workflow and winning back their time
          </p>
        </div>
      </div>
      <a
        href={siteLinks.community}
        target="_blank"
        className="flex items-center justify-center rounded-md bg-[#6599FF] px-6 py-2 text-center text-xs font-semibold transition-all sm:px-8 sm:py-4 sm:text-base"
        onClick={handleEventRegiter}
      >
        Go to Facebook
      </a>
    </div>
  );
};

export default FacebookBanner;
